import React, { useEffect, useState, useCallback } from 'react';
import { outreachService } from '../../../services/outreachService';
import { AddSuppressionModal } from './AddSuppressionModal';

const REASONS = [
  'unsubscribe',
  'hard_bounce',
  'complaint',
  'manual',
  'domain_unsubscribe_threshold',
];

export function OutreachSuppression() {
  const [items, setItems] = useState([]);
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showAdd, setShowAdd] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await outreachService.listSuppression({ reason: reason || undefined });
      setItems(data.items);
    } catch (e) {
      setError(e?.response?.data?.detail || e.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  }, [reason]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-semibold">Outreach — Suppression List</h1>
        <div className="flex gap-2">
          <a
            href={outreachService.exportCsvUrl()}
            className="px-3 py-2 bg-surface-sunken hover:bg-surface-sunken/80 rounded text-sm"
          >Export CSV</a>
          <button
            onClick={() => setShowAdd(true)}
            aria-label="Add suppression entry"
            className="px-3 py-2 bg-accent text-white hover:bg-accent-hover rounded text-sm"
          >+ Add</button>
        </div>
      </div>

      <div className="mb-4">
        <label htmlFor="reason-filter" className="text-sm text-ink-muted mr-2">Filter by reason:</label>
        <select
          id="reason-filter"
          value={reason}
          onChange={e => setReason(e.target.value)}
          className="border rounded px-2 py-1 text-sm border-border-strong"
        >
          <option value="">All</option>
          {REASONS.map(r => <option key={r} value={r}>{r}</option>)}
        </select>
      </div>

      {loading && <div>Loading…</div>}
      {error && <div className="text-danger">{error}</div>}

      {!loading && !error && (
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left border-b">
              <th scope="col" className="py-2">Email / Domain</th>
              <th scope="col">Reason</th>
              <th scope="col">Source</th>
              <th scope="col">Notes</th>
              <th scope="col">Created</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan="5" className="py-4 text-ink-muted">No suppression entries match this filter.</td></tr>
            )}
            {items.map(row => (
              <tr key={row.id} className="border-b">
                <td className="py-2 font-mono">{row.email || `@${row.domain}`}</td>
                <td>{row.reason}</td>
                <td>{row.source}</td>
                <td className="text-ink-muted">{row.notes}</td>
                <td className="text-ink-muted">{new Date(row.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {showAdd && (
        <AddSuppressionModal
          onClose={() => setShowAdd(false)}
          onSaved={() => { setShowAdd(false); load(); }}
        />
      )}
    </div>
  );
}
